<div class="row p-5">
  <div class="col-md-3">
    <ul>
      <b>Profile</b>
      <li>Personal Information</li>
      <li>Company Information</li>
      <li>Contact Information</li>
    </ul>
    <ul>
      <b>Capabilities</b>
      <li>Machine Information</li>
      <li>Certifications</li>
    </ul>
    <ul>
      <b>Security</b>
      <li>Password</li>
      <li>Privacy</li>
    </ul>
    <ul>
      <b>Settings</b>
    </ul>
  </div>
  <div class="col-md-9 new-po-list">
      <div class="row bg-light">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6">
              <span>Username</span>
              <br>
                <p *ngIf="profileDetails">{{profileDetails.email}}</p>
            </div>
            <div class="col-md-6 text-right">
              <a data-toggle="modal" data-target="#profileDetailModal" (click)="setProfileDetailsForm()" class="btn btn-success">Edit</a>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <span>Fullname</span>
              <br>
                <p *ngIf="profileDetails">{{profileDetails.name}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <span>Gender</span>
              <br>
                <p>Male</p>
            </div>
            <div class="col-md-6">
              <span>Country</span>
              <br>
                <span *ngIf="profileDetails">{{profileDetails.country}}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <span>State</span>
              <br>
                <p *ngIf="profileDetails">{{profileDetails.state}}</p>
            </div>
            <div class="col-md-6">
              <span>Language</span>
              <br>
                <p>English</p>
            </div>
          </div>
        </div>
      </div>
      <br>
      <br>
      <br>
      <div class="row bg-light">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6">
                <p>Company Details</p>
            </div>
            <div class="col-md-6 text-right">
              <a data-toggle="modal" data-target="#companyDetailModal" (click)="setCompanyDetailsForm()" class="btn btn-success">Edit</a>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <span>Company Name</span>
              <br>
                <p *ngIf="profileDetails">{{profileDetails.company_detail.company_name}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <span>Established in</span>
              <br>
                <p *ngIf="profileDetails">{{profileDetails.company_detail.established_in_year}}</p>
            </div>
            <div class="col-md-6">
              <span>Website</span>
              <br>
                <span *ngIf="profileDetails">{{profileDetails.company_detail.website_url}}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <span>Type of Industry/Organization</span>
              <br>
                <p *ngIf="profileDetails">{{profileDetails.company_detail.industry_type}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <span>Name of Partner/Director/Proprietor</span>
              <br>
                <p *ngIf="profileDetails">{{profileDetails.company_detail.proprietor_first_name+" "+profileDetails.company_detail.proprietor_last_name}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <span>Email</span>
              <br>
                <p *ngIf="profileDetails">{{profileDetails.company_detail.proprietor_email}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <span>Registered Address</span>
              <br>
                <p *ngIf="profileDetails">{{profileDetails.primary_address.address}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <span>City</span>
              <br>
                <p *ngIf="profileDetails">{{profileDetails.primary_address.city}}</p>
            </div>
            <div class="col-md-6">
              <span>State</span>
              <br>
                <p *ngIf="profileDetails">{{profileDetails.primary_address.state}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <span>Zip Code</span>
              <br>
                <p *ngIf="profileDetails">{{profileDetails.primary_address.pin_code}}</p>
            </div>
            <div class="col-md-6">
              <span>Country</span>
              <br>
                <p *ngIf="profileDetails">{{profileDetails.primary_address.country}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <span>Total number of Employees</span>
              <br>
                <p *ngIf="profileDetails">{{profileDetails.company_detail.no_of_employees}}</p>
            </div>
            <div class="col-md-6">
              <span>Company Pan Number</span>
              <br>
                <p *ngIf="profileDetails">{{profileDetails.company_detail.pan_number}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <span>Last Year's Revenue (Cr.)</span>
              <br>
                <p *ngIf="profileDetails">{{profileDetails.company_detail.last_year_revenue}}</p>
            </div>
            <div class="col-md-6">
              <span>Company GSTIN Number</span>
              <br>
                <p *ngIf="profileDetails">{{profileDetails.company_detail.gst_number}}</p>
            </div>
          </div>
        </div>
      </div>
      <br>
      <br>
      <br>
      <div class="row bg-light">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6">
                <p>My Contact Details</p>
            </div>
            <div class="col-md-6 text-right">
              <a data-toggle="modal" data-target="#contactDetailModal" (click)="setVerifyMobileForm()" class="btn btn-success">Edit</a>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <span>User</span>
              <br>
                <p *ngIf="profileDetails">{{profileDetails.name}}</p>
            </div>
            <div class="col-md-4">
              <span>Email</span>
              <br>
                <p *ngIf="profileDetails">{{profileDetails.email}}</p>
            </div>
            <div class="col-md-4">
              <span>Mobile</span>
              <br>
                <p *ngIf="profileDetails">{{profileDetails.phone_number}}</p>
            </div>
          </div>
        </div>
      </div>

      <br>
      <br>
      <br>
      <div class="row bg-light">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6">
              <p>Manufacturing Processes</p>
            </div>
            <div class="col-md-6 text-right">
              <a data-toggle="modal" data-target="#printProcessModal" (click)="setPrintProcessForm()" class="btn btn-success">Edit</a>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </div>
          </div>
          <div class="row">
            <p *ngFor="let printProcess of printProcessViewList; let i = index">
              <span>{{i+1}}</span>&nbsp;&nbsp;{{printProcess.name}}
              &nbsp;&nbsp;&nbsp;
            </p>
          </div>
        </div>
      </div>

      <br>
      <br>
      <br>
      <div class="row bg-light">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6">
              <p>Your Machine Details</p>
            </div>
            <div class="col-md-6 text-right">             
              <a data-toggle="modal" data-target="#machineFormModal" (click)="setMachineData()" class="btn btn-success">Edit</a>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-sm-12" *ngIf="machineDetailsViewArray">
              <table>
                <tr>
                  <th>Sr</th>
                  <th>Brand</th>
                  <th>Model</th>
                  <th>Machine Name/Type</th>
                  <th>Capacity/Specifications</th>
                  <th>No of Machines</th>
                  <th>Monthly Spare Capacity</th>
                </tr>
                <tr *ngFor="let item of machineDetailsViewArray; let machineIndex = index;">
                  <td>
                    {{ machineIndex + 1 }}
                  </td>
                  <td>
                    {{ item.brand_name }}
                  </td>
                  <td>
                    {{ item.model_number || "null" }}
                  </td>
                  <td>
                    {{ item.vendor_machine_name }}
                  </td>
                  <td>
                    <p *ngFor="let spec of item.vom_specifications;">
                      {{spec.master_specification_name}}
                      {{spec.machine_capacity}}
                      {{spec.machine_specification_unit_name}}
                    </p>
                  </td>
                  <td>
                    {{item.number_of_machines}}
                  </td>
                  <td>
                    {{item.spare_capacity}}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>

      <br>
      <br>
      <br>
      <div class="row bg-light">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6">
              <p>Industry Verticals & Clients</p>
            </div>
            <div class="col-md-6 text-right">
              <a data-toggle="modal" data-target="#industryModal" (click)="setIndustryForm()" class="btn btn-success">Edit</a>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-sm-12" *ngIf="industryViewList">
              <table>
                <tr>
                  <th>Sr</th>
                  <th>Industry Name</th>
                  <th>Clients Name</th>
                </tr>
                <tr *ngFor="let item of industryViewList; let industryIndex = index;">
                  <td>
                    {{ industryIndex + 1 }}
                  </td>
                  <td>
                    {{ item.industry_name }}
                  </td>
                  <td>
                    {{item.client_name}}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>

      <br>
      <br>
      <br>
      <div class="row bg-light">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6">
              <p>Certifications</p>
            </div>
            <div class="col-md-6 text-right">
              <a data-toggle="modal" data-target="#certificateModal" (click)="setCertificationForm()" class="btn btn-success">Edit</a>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-sm-12" *ngIf="certificationsViewList">
              <table>
                <tr>
                  <th>Sr</th>
                  <th>Certification Name</th>
                </tr>
                <tr *ngFor="let item of certificationsViewList; let certificationIndex = index;">
                  <td>
                    {{ certificationIndex + 1 }}
                  </td>
                  <td>
                    {{ item.name }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>

      <br>
      <br>
      <br>
      <div class="row bg-light">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12">
              <h5>Security</h5>
              <input type="text" placeholder="**********" readonly="true">
              <a data-toggle="modal" data-target="#passwordModal" (click)="setPasswordForm()" class="btn btn-success">Update</a>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <h5>Privacy Policy</h5>
              <p>Download Privacy Terms and Conditions</p>
            </div>
          </div>
        </div>
      </div>

      <br>
      <br>
      <br>
      <div class="row bg-light">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12">
              <h5>Newsletter Section</h5>
              <p>comming soon</p>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>


<div class="modal" id="profileDetailModal">
  <div class="modal-dialog">
    <div class="modal-content">
      <!-- Modal body -->
      <div class="modal-body">  
        <form [formGroup]="profileDetailForm">
          <button class="close" data-dismiss="modal">&times;</button>
          <div class="form-group">
            <label for="name">Name*</label>
            <input type="text" name="name" class="form-control" formControlName="name" [ngClass]="{ 'is-invalid': profileDetailFormSubmitted && f.name.errors }">
            <div *ngIf="profileDetailFormSubmitted && f.name.errors && f.name.errors.required" class="invalid-feedback">Name is required</div>
          </div>
          <div class="form-group">
            <label for="country">Country*</label>
            <input type="text" name="country" class="form-control" formControlName="country" autocomplete="off" [ngClass]="{ 'is-invalid': profileDetailFormSubmitted && f.country.errors }">
            <div *ngIf="profileDetailFormSubmitted && f.country.errors && f.country.errors.required" class="invalid-feedback">Country is required</div>
          </div>
          <div class="form-group">
            <label for="state">State*</label>
            <input type="text" name="state" class="form-control" formControlName="state" autocomplete="off" [ngClass]="{ 'is-invalid': profileDetailFormSubmitted && f.state.errors }">
            <div *ngIf="profileDetailFormSubmitted && f.state.errors && f.state.errors.required" class="invalid-feedback">State is required</div>
          </div>
          <div class="form-group">
            <label for="gender">Gender*</label>
            <input type="text" name="gender" class="form-control" formControlName="gender" autocomplete="off" [ngClass]="{ 'is-invalid': profileDetailFormSubmitted && f.gender.errors }">
            <div *ngIf="profileDetailFormSubmitted && f.gender.errors && f.gender.errors.required" class="invalid-feedback">State is required</div>
          </div>
          <div class="form-group">
            <label for="language">Language*</label>
            <input type="text" name="language" class="form-control" formControlName="language" autocomplete="off" [ngClass]="{ 'is-invalid': profileDetailFormSubmitted && f.language.errors }">
            <div *ngIf="profileDetailFormSubmitted && f.language.errors && f.language.errors.required" class="invalid-feedback">State is required</div>
          </div>
          <button class="btn blue-btn btn-block" (click)='submitProfileDetails()' >Submit</button>
        </form>
      </div>
    </div>
  </div>
</div>


<div class="modal" id="companyDetailModal">
  <div class="modal-dialog">
    <div class="modal-content">
      <!-- Modal body -->
      <div class="modal-body">  
        <form [formGroup]="companyDetailForm">
          <button class="close" data-dismiss="modal">&times;</button>
          <div class="form-group">
            <label for="name">Name*</label>
            <input type="text" name="company_name" class="form-control" formControlName="company_name" [ngClass]="{ 'is-invalid': companyDetailFormSubmitted && cd.company_name.errors }">
            <div *ngIf="companyDetailFormSubmitted && cd.company_name.errors && cd.company_name.errors.required" class="invalid-feedback">Name is required</div>
          </div>
          <div class="form-group">
            <label for="website_url">Website Url*</label>
            <input type="text" name="website_url" class="form-control" formControlName="website_url" autocomplete="off" [ngClass]="{ 'is-invalid': companyDetailFormSubmitted && cd.website_url.errors }">
          </div>
          <div class="form-group">
            <label for="established_in_year">Established in year*</label>
            <input type="number" name="established_in_year" class="form-control" formControlName="established_in_year" [ngClass]="{ 'is-invalid': companyDetailFormSubmitted && cd.established_in_year.errors }">
            <div *ngIf="companyDetailFormSubmitted && cd.established_in_year.errors && cd.established_in_year.errors.required" class="invalid-feedback">Name is required</div>
          </div>
          <div class="form-group">
            <label class="blue-color-heading">Type of Industry/Organization *</label>
            <select name="industry_type" class="form-control" formControlName="industry_type" [ngClass]="{ 'is-invalid': companyDetailFormSubmitted && cd.industry_type.errors }">
              <option value="private ltd">Private Ltd</option>
              <option value="public ltd">Public Ltd</option>
              <option value="llp">LLP/Partnership</option>
              <option value="partnership">Partnership</option>
              <option value="proprietorship">Proprietorship</option>
              <option value="huf">HUF</option>
              <option value="other">Other</option>
            </select>
            <div *ngIf="companyDetailFormSubmitted && cd.industry_type.errors && cd.industry_type.errors.required" class="invalid-feedback">Industry/Organization is required</div>
          </div>
          <div class="form-group">
            <label for="proprietor_first_name">First Name of Proprietor/Director</label>
            <input type="text" name="proprietor_first_name" class="form-control" formControlName="proprietor_first_name" min="1" max="1000000">
            <div *ngIf="companyDetailFormSubmitted && cd.proprietor_first_name.errors && cd.proprietor_first_name.errors.required" class="invalid-feedback">first name is required</div>
          </div>
          <div class="form-group">
            <label for="proprietor_last_name">Last Name of Proprietor/Directors</label>
            <input type="text" name="proprietor_last_name" class="form-control" formControlName="proprietor_last_name" min="1" max="1000000">
            <div *ngIf="companyDetailFormSubmitted && cd.proprietor_last_name.errors && cd.proprietor_last_name.errors.required" class="invalid-feedback">last name is required</div>
          </div>
                    <div class="form-group">
            <label for="proprietor_email">Email</label>
            <input type="email" name="proprietor_email" class="form-control" formControlName="proprietor_email" min="1" max="1000000">
            <div *ngIf="companyDetailFormSubmitted && cd.proprietor_email.errors && cd.proprietor_email.errors.required" class="invalid-feedback">email is required</div>
          </div>
          <div class="form-group">
            <label for="no_of_employees">Total no of Employees</label>
            <input type="number" name="no_of_employees" class="form-control" formControlName="no_of_employees" min="1" max="1000000">
            <div *ngIf="companyDetailFormSubmitted && cd.no_of_employees.errors && cd.no_of_employees.errors.required" class="invalid-feedback">Total no. of employees is required</div>
          </div>
          <div class="form-group">
            <label for="last_year_revenue">Last Year's Revenue(Cr.)</label>
            <input type="number" name="last_year_revenue" class="form-control" formControlName="last_year_revenue" min="1" max="1000000">
          </div>
          <div class="form-group">
            <label for="pan_number">Company Pan Number *</label>
            <input type="text" name="pan_number" class="form-control" formControlName="pan_number" [ngClass]="{ 'is-invalid':companyDetailFormSubmitted && cd.pan_number.errors }" />
            <div *ngIf="companyDetailFormSubmitted && cd.pan_number.errors && cd.pan_number.errors.required" class="invalid-feedback">Pan number is required</div>
          </div>
          <div class="form-group ">
            <label for="gst_number">Company GSTIN Number</label>
            <input type="text" name="gst_number" class="form-control" formControlName="gst_number" autocomplete="off" [ngClass]="{ 'is-invalid': companyDetailFormSubmitted && cd.gst_number.errors }">
            <div *ngIf="companyDetailFormSubmitted && cd.gst_number.errors && cd.gst_number.errors.required" class="invalid-feedback">Gst Number is required</div>
          </div>
          <div class="form-group">
            <label for="address">Address*</label>
            <input type="text" name="address" class="form-control" formControlName="address" autocomplete="off" [ngClass]="{ 'is-invalid': companyDetailFormSubmitted && cd.address.errors }">
            <div *ngIf="companyDetailFormSubmitted && cd.address.errors && cd.address.errors.required" class="invalid-feedback">State is required</div>
          </div>
          <div class="form-group">
            <label for="city">City*</label>
            <input type="text" name="city" class="form-control" formControlName="city" autocomplete="off" [ngClass]="{ 'is-invalid': companyDetailFormSubmitted && cd.city.errors }">
            <div *ngIf="companyDetailFormSubmitted && cd.city.errors && cd.city.errors.required" class="invalid-feedback">City is required</div>
          </div>
          <div class="form-group">
            <label for="pin_code">Pin Code*</label>
            <input type="text" name="pin_code" class="form-control" formControlName="pin_code" autocomplete="off" [ngClass]="{ 'is-invalid': companyDetailFormSubmitted && cd.pin_code.errors }">
            <div *ngIf="companyDetailFormSubmitted && cd.pin_code.errors && cd.city.errors.required" class="invalid-feedback">City is required</div>
          </div>
          <div class="form-group">
            <label for="state">State*</label>
            <input type="text" name="state" class="form-control" formControlName="state" autocomplete="off" [ngClass]="{ 'is-invalid': companyDetailFormSubmitted && cd.state.errors }">
            <div *ngIf="companyDetailFormSubmitted && cd.state.errors && cd.state.errors.required" class="invalid-feedback">State is required</div>
          </div>
          <div class="form-group">
            <label for="country">Country*</label>
            <input type="text" name="country" class="form-control" formControlName="country" autocomplete="off" [ngClass]="{ 'is-invalid': companyDetailFormSubmitted && cd.country.errors }">
            <div *ngIf="companyDetailFormSubmitted && cd.country.errors && cd.country.errors.required" class="invalid-feedback">Country is required</div>
          </div>
          <button class="btn blue-btn btn-block" (click)='submitCompanyDetails()' >Submit</button>
        </form>
      </div>
    </div>
  </div>
</div>


<div class="modal" id="contactDetailModal">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <!-- Modal body -->
      <div class="modal-body">
        <form [formGroup]="verifyMobileForm">
          <div class="form-group">
            <button class="close" data-dismiss="modal">&times;</button>
            <label for="contact_no">Mobile Number</label>
            <input type="number" name="contact_no" class="form-control" formControlName="contact_no">
            <div *ngIf="verifyMobileSubmitted && cpd.contact_no.errors && cpd.contact_no.errors.required" class="invalid-feedback">Mobile Number is required</div>
          </div>
          <button class="btn btn-light btn-block" (click)='sendOtp()'>Submit</button>
        </form>    
      </div>
    </div>
  </div>
</div>


<div class="modal" id="submitOtpModal">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <!-- Modal body -->
      <div class="modal-body">
        <form [formGroup]="verifyMobileForm">
          <div class="form-group">
            <button class="close" data-dismiss="modal">&times;</button>
            <label for="otp">Enter OTP</label>
            <input type="text" name="otp" class="form-control" formControlName="otp">
            <a (click)='sendOtp()' class="resend-otp"><small><i>Didn't receive? click to resend OTP.</i></small></a>
            <br>
            <a (click)='wrongNumber()' class="resend-otp"><small><i>wrong number? click to enter mobile number again.</i></small></a>
          </div>
          <button class="btn btn-light btn-block" (click)='submitOtp()'>Submit</button>
        </form>    
      </div>
    </div>
  </div>
</div>


<div class="modal" id="printProcessModal">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <button class="close" data-dismiss="modal">&times;</button>
        <form [formGroup]="printProcessForm">
          <div class="form-group">
            <ng-multiselect-dropdown
                [data]="printProcesses"
                formControlName="selectedPrintProcesses"
                [settings]="printProcessDropdownSettings"
                (onSelect)="onPrintProcessSelect($event)"
                (onDeSelect)="onPrintProcessDeselect($event)"
              >
            </ng-multiselect-dropdown>
            <small><a data-toggle="modal" data-target="#newPrintProcessFormModal" (click)="setNewPrintProcessForm()" class="new-industry-link">Didn't find your Manufacturing Industry? Click to add it.</a></small>
          </div>
          <button class="btn btn-light btn-block" (click)='submitPrintProcessForm()'>Submit</button>
        </form>    
      </div>
    </div>
  </div>
</div>

<!-- new print process model -->
<div class="modal fade" id="newPrintProcessFormModal">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-body">  
        <form [formGroup]="newPrintProcessForm">
          <div class="form-group">
            <button class="close" data-dismiss="modal">&times;</button>
            <label for="new_print_process_name">Enter Manufacturing Process Name</label>
            <input type="text" name="new_print_process_name" class="form-control" formControlName="new_print_process_name" autocomplete="off">
          </div>
          <button class="btn blue-btn btn-block" (click)='submitNewPrintProcess()' [disabled]="!newPrintProcessForm.valid">Submit</button>
        </form>
      </div>
    </div>
  </div>
</div>


<div class="modal" id="certificateModal">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <button class="close" data-dismiss="modal">&times;</button>
        <form [formGroup]="certificateForm">
          <div class="form-group">
            <ng-multiselect-dropdown
              [data]="certificates"
              formControlName="selectedCertificates"
              [settings]="certificatesDropdownSettings"
              (onSelect)="onCertificatesSelect($event)"
              (onDeSelect)="onCertificatesDeselect($event)"
            >
            </ng-multiselect-dropdown>
            <small><a data-toggle="modal" data-target="#newCertificateFormModal" (click)="setNewCertificateForm()" class="new-industry-link">Didn't find Certification? Click to add it.</a></small>
          </div>
          <button class="btn btn-light btn-block" (click)='submitCertificationForm()'>Submit</button>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="machineFormModal">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Machine Details</h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">
        <form [formGroup]="machineForm" (ngSubmit)="submitMachineDetails()">
          <div class="display-flex-lg col-sm-12 no-padding">
            <div class="form-group col-sm-4 no-padding">
              <label class="blue-color-heading">Machine Name / Type *</label>
              <ng-autocomplete [data]="machines"
                [searchKeyword]="keyword"
                (inputChanged)='onChangeMachineSearch($event)'
                (selected)='onMachineSelectSetSpecs($event)'
                [itemTemplate]="itemTemplate" 
                class="form-control" 
                formControlName="machine_name"
                style="width:350px; 
                    box-shadow: none;
                  /* border-radius: 23px; */
                  border: none;
                  border: solid 1px #e0e7ff;
                  background-color: rgba(224, 231, 255, 0.2);
                  height: 42px;">
              </ng-autocomplete>
              <ng-template #itemTemplate let-item>
                  <a [innerHTML]="item.display_name"></a>
              </ng-template>
              <div *ngIf="machineFormSubmitted && mf.machine_name.errors && mf.machine_name.errors.required" class="text-danger">Machine Name is required</div>
            </div>
            <div class="form-group col-sm-4 no-padding-right">
              <label class="blue-color-heading">Brand Name *</label>
              <div class="ng-autocomplete">
                  <ng-autocomplete [data]="brands"
                    [searchKeyword]="keyword"
                    (inputChanged)='onChangeBrandSearch($event)'
                    [itemTemplate]="itemTemplate"
                    class="form-control" 
                    formControlName="brand_name"
                    style="width:325px;">
                  </ng-autocomplete>
              </div>
              <ng-template #itemTemplate let-item>
                  <a [innerHTML]="item.display_name"></a>
              </ng-template>
              <div *ngIf="machineFormSubmitted && mf.brand_name.errors && mf.brand_name.errors.required" class="text-danger">Brand Name is required</div>
            </div>
            <div class="form-group col-sm-4 no-padding">
              <label class="blue-color-heading">Model Number *</label>
              <input type="text" class="form-control" formControlName="model_number">
              <div *ngIf="machineFormSubmitted && mf.model_number.errors && mf.model_number.errors.required" class="text-danger">Model Number is required</div>
            </div>
          </div>
          <div class="display-flex-lg col-sm-12 no-padding">
            <div class="form-group col-sm-4 no-padding">
              <label class="blue-color-heading">No. of Machines *</label>
              <input type="number" class="form-control" formControlName="number_of_machines" min="1" max="999" >
              <div *ngIf="machineFormSubmitted && mf.number_of_machines.errors && mf.number_of_machines.errors.required" class="text-danger">Quantity is required</div>
            </div>
            <div class="form-group col-sm-4">
              <label class="blue-color-heading">Monthly Spare Capacity (%) *</label>
              <input type="number" class="form-control" formControlName="spare_capacity" min="1" max="999" >
              <div *ngIf="machineFormSubmitted && mf.spare_capacity.errors && mf.spare_capacity.errors.required" class="text-danger">Spare Capacity is required</div>
            </div>
            <div class="form-group col-sm-4 no-padding">
              <label class="blue-color-heading">Machine Speciality if any?</label>
              <input type="text" class="form-control" formControlName="machine_speciality" >
            </div>                    
          </div>
          <div formArrayName="vom_specifications">
            <h6>Specification Details</h6>
            <div class="display-flex-lg col-sm-12" *ngFor="let item of machineForm.get('vom_specifications')['controls']; let i = index" [formGroupName]="i">
              <p class="margin-auto">{{i+1}}.</p>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <div class="form-group col-sm-4">
                <label class="blue-color-heading">Specification *</label>
                <div class="ng-autocomplete">
                  <ng-autocomplete [data]="masterSpecs"
                    [searchKeyword]="keyword"
                    [itemTemplate]="itemTemplate"
                    class="form-control" 
                    formControlName="master_specification_name"
                    style="width:350px;">
                  </ng-autocomplete>
                </div>
                <ng-template #itemTemplate let-item>
                    <a [innerHTML]="item.name"></a>
                </ng-template>
                <div *ngIf="machineFormSubmitted && machineForm.get('vom_specifications')['controls'][i].get('master_specification_name').errors?.required" class="text-danger">Specification is required</div>
              </div>
              <div class="form-group col-sm-3">
                <label class="blue-color-heading">Size/Capacity *</label>
                <input type="text" class="form-control" formControlName="machine_capacity">
                <div *ngIf="machineFormSubmitted && machineForm.get('vom_specifications')['controls'][i].get('machine_capacity').errors?.required" class="text-danger">Capacity is required</div>
              </div>
              <div class="form-group col-sm-4 no-padding">
                <label class="blue-color-heading">Unit *</label>
                <div class="ng-autocomplete">
                    <ng-autocomplete [data]="machineUnits"
                      [searchKeyword]="keyword"
                      [itemTemplate]="itemTemplate"
                      class="form-control" 
                      formControlName="machine_specification_unit_name"
                      style="width:300px;">
                    </ng-autocomplete>
                </div>
                <ng-template #itemTemplate let-item>
                    <a [innerHTML]="item.name"></a>
                </ng-template>
                <div *ngIf="machineFormSubmitted && machineForm.get('vom_specifications')['controls'][i].get('machine_specification_unit_name').errors?.required" class="text-danger">Unit is required</div>

              </div>
              <div class="col-sm-1 top-margin-sm">
                
                <button type="button" class="btn btn-danger btn-sm" (click)="removeMachineSpec(i)">Remove</button>
              </div>
            </div>
            <div class="text-right">
            <button type="button" class="btn btn-sm add-machine-data-btn btn-sm" (click)="addMachineSpec()">Add Specification</button>
             
            </div>
          </div>
          <div class="col-sm-12 text-center">
            <button type="submit" class="btn blue-btn top-margin">Add</button>
          </div>
        </form>     
      </div>
      <div class="modal-footer">
        <div class="col-md-12 col-sm-12 capabilities-info no-padding" *ngIf="machineDetailsArray.length > 0">
          <h5>Your Machine Details</h5>
          <table>
            <tr>
              <th>Brand</th>
              <th>Model</th>
              <th>Machine Name/Type</th>
              <th>Machine Capacity/Specifications</th>
              <th>No of Machines</th>
              <th>Monthly Spare Capacity</th>
              <th>Delete</th>
            </tr>
            <tr *ngFor="let item of machineDetailsArray; let i = index">
              <td>
                {{item.brand_name}}
              </td>
              <td>
                {{item.model_number}}
              </td>
              <td>
                {{item.vendor_machine_name}}
              </td>
              <td>
                <p *ngFor="let spec of item.vom_specifications;">
                  {{spec.master_specification_name}}
                  {{spec.machine_capacity}}
                  {{spec.machine_specification_unit_name}}
                </p>
              </td>
              <td>
                {{item.number_of_machines}}
              </td>
              <td>
                {{item.spare_capacity}}
              </td>
              <td>
                <span class="remove-icon" (click)="deleteFromMachineArray(i)">&times;</span>
              </td>
            </tr>
          </table>
        </div>
        <div class="col-md-12 col-sm-12 no-padding top-margin" *ngIf="machineDetailsArray.length == 0">
          No Machines found. Please add one.
        </div>
        <button class="btn blue-btn btn-block" [disabled]="!isActiveMachineSubmit"(click)='submitMachineAllDetails()'>Submit</button>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="industryModal">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <button class="close" data-dismiss="modal">&times;</button>
        <form [formGroup]="industriesForm">
            <div class="col-sm-12">
                <div class="col-sm-12">
                  <p>Select the industry Verticals you are Specialized working with</p>
                  <ng-multiselect-dropdown
                      [data]="vendorIndustries"
                      formControlName="selectedVendorIndustries"
                      [settings]="industryDropdownSettings"
                      (onSelect)="onIndustrySelect($event)"
                      (onDeSelect)="onIndustryDeselect($event)"
                    >
                  </ng-multiselect-dropdown>
                  <small><a data-toggle="modal" data-target="#newIndustryFormModal" (click)="setNewIndustryForm()" class="new-industry-link">Didn't find your industry? Click to add it.</a></small>
                </div>
                <div class="col-sm-12" formArrayName="vendor_industries_clients_attributes">
                  <p class="top-margin-sm">Your Major Clients with respect to industries</p>

                  <table>
                    <tr>
                        <th>Sr</th>
                        <th>Industry Name</th>
                        <th>Client Names</th>
                    </tr>
                    <tr *ngFor="let item of industriesForm.get('vendor_industries_clients_attributes')['controls']; let i = index" [formGroupName]="i">
                        <td>{{i+1}}</td>
                        <td class="display-flex-lg">
                          {{item.controls['industry_name'].value}}
                        </td>
                        <td>
                          <input formControlName="client_name" placeholder="eg: Mahindra, Tata, Sony" class="form-control">
                          <div *ngIf="industriesFormSubmitted && industriesForm.get('vendor_industries_clients_attributes')['controls'][i].get('client_name').errors?.required" class="text-danger">Atleast 1 client is required.</div>
                        </td>
                    </tr>
                  </table>
                </div>
            </div>
          <br>
          <button class="btn btn-light btn-block" (click)='submitIndustryForm()'>Submit</button>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- new industry model -->
<div class="modal fade" id="newIndustryFormModal">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-body">  
        <form [formGroup]="newIndustryForm">
          <div class="form-group">
            <button class="close" data-dismiss="modal">&times;</button>
            <label for="new_industry_name">Enter Industry Name</label>
            <input type="text" name="new_industry_name" class="form-control" formControlName="new_industry_name" autocomplete="off">
          </div>
          <button class="btn blue-btn btn-block" (click)='submitNewIndustry()' [disabled]="!newIndustryForm.valid">Submit</button>
        </form>
      </div>
    </div>
  </div>
</div>


<!-- new certificates form model -->
<div class="modal fade" id="newCertificateFormModal">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-body">  
        <form [formGroup]="newCertificateForm">
          <div class="form-group">
            <button class="close" data-dismiss="modal">&times;</button>
            <label for="new_certificate_name">Enter Certificate Name</label>
            <input type="text" name="new_certificate_name" class="form-control" formControlName="new_certificate_name" autocomplete="off">
          </div>
          <button class="btn blue-btn btn-block" (click)='submitNewCertificate()' [disabled]="!newCertificateForm.valid">Submit</button>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="passwordModal">
  <div class="modal-dialog">
    <div class="modal-content">
      <!-- Modal body -->
      <div class="modal-body">  
        <form [formGroup]="passwordForm">
          <button class="close" data-dismiss="modal">&times;</button>
          <div class="form-group">
            <label for="current_password">Current Password*</label>
            <input type="password" name="current_password" class="form-control" formControlName="current_password" [ngClass]="{ 'is-invalid': passwordFormSubmitted && pf.current_password.errors }">
            <div *ngIf="passwordFormSubmitted && pf.current_password.errors && pf.current_password.errors.required" class="invalid-feedback">Current Password is required</div>
          </div>
          <div class="form-group">
            <label for="password">New Password*</label>
            <input type="password" name="password" class="form-control" formControlName="password" autocomplete="off" [ngClass]="{ 'is-invalid': passwordFormSubmitted && pf.password.errors }">
            <div *ngIf="passwordFormSubmitted && pf.password.errors && pf.password.errors.required" class="invalid-feedback">New password is required</div>
          </div>
          <div class="form-group">
            <label for="password_confirmation">Password Confirmation*</label>
            <input type="password" name="password_confirmation" class="form-control" formControlName="password_confirmation" autocomplete="off" [ngClass]="{ 'is-invalid': passwordFormSubmitted && pf.password_confirmation.errors }">
            <div *ngIf="passwordFormSubmitted && pf.password_confirmation.errors && pf.password_confirmation.errors.required" class="invalid-feedback">Password Confirmation is required</div>
          </div>
          <button class="btn blue-btn btn-block" (click)='submitPasswordForm()' >Submit</button>
        </form>
      </div>
    </div>
  </div>
</div>
